import { Flex } from '@lemonade-hq/cdk';
import styled from 'styled-components';
import { MediumSmallTitle } from '../shared';

const ChartIframe = styled.iframe`
  width: 100%;
  height: 500px;
  border: none;
`;

export const Chart = () => {
  return (
    <Flex flexDirection="column" width="100%" gap="18px" my="30px">
      <MediumSmallTitle>LMND Stock Chart</MediumSmallTitle>
      <ChartIframe
        src="https://www.tradingview.com/widgetembed/?frameElementId=tradingview_9a757&symbol=NYSE%3ALMND&interval=D&hidesidetoolbar=1&symboledit=0&saveimage=0&toolbarbg=f1f3f6&studies=[]&theme=light&style=3&timezone=exchange&withdateranges=1&hideideas=0&hide_top_toolbar=1&hide_tradingview_branding=1&hide_legend_bar=1&hide_volume=1&hide_side_toolbar=1&hide_tradingview_branding=1&hide_legend_bar=1&hide_volume=1&hide_side_toolbar=1"
        title="Lemonade Stock Chart"
      />
    </Flex>
  );
};
